import { useMapContext } from 'widgets/choroplethMap/contexts/mapContext';
import { useEffect, useCallback } from 'react';
import { useChoroplethContext } from 'widgets/choroplethMap/contexts/choroplethContext';

export default function usePolygonHover({
	sourceName,
	layerName,
	minzoom,
	maxzoom,
}: {
	sourceName: string;
	layerName: string;
	minzoom: number;
	maxzoom: number;
}) {
	const [{ map }] = useMapContext();
	const [{ hoveredPolygon, choroplethOpacityValues }, { setHoveredPolygon }] = useChoroplethContext();

	const isListening = useCallback(() => {
		const zoom = map.getZoom();
		if (zoom <= maxzoom && zoom >= minzoom) {
			return true;
		} else {
			return false;
		}
	}, [map, minzoom, maxzoom]);

	useEffect(() => {
		if (!map) return;
		const source = map.getSource(sourceName);
		if (!source) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		const onMouseMove = (e: any) => {
			if (!isListening()) return;
			const features = map.queryRenderedFeatures(e.point, { layers: [layerName] });
			const feature = features[0];
			setHoveredPolygon(feature);
		};
		map.on('mousemove', onMouseMove);
		return () => {
			map.off('mousemove', onMouseMove);
		};
	}, [map, isListening, layerName, setHoveredPolygon, sourceName]);

	useEffect(() => {
		if (!map) return;
		map.setPaintProperty(layerName, 'fill-opacity', choroplethOpacityValues ?? 0.5);
	}, [hoveredPolygon, map, choroplethOpacityValues, layerName]);
}
